import { create } from 'zustand';

const LoginFormDialogDefaultState = {
    isOpen: false,
    isOrder: false,
    orderSessionDate: '',
    referrer: '',
    path: ''
};

export const useLoginFormDialogStore = create<LoginFormDialogType>()((set) => ({
    ...LoginFormDialogDefaultState,
    action: {
        setIsOpen: (isOpen) => set(() => ({ isOpen })),
        setOrderSessionDate: (orderSessionDate) => set(() => ({ orderSessionDate })),
        setIsOrder: (isOrder) => set(() => ({ isOrder })),
        setReferrer: (referrer) => set(() => ({ referrer })),
        setPath: (path) => set(() => ({ path }))
    },
}));
interface LoginFormDialogType {
    isOpen: boolean;
    orderSessionDate: string;
    isOrder: boolean;
    referrer: string;
    path: string;
    action: {
        setIsOpen: (isOpen: boolean) => void;
        setIsOrder: (isOrder: boolean) => void;
        setOrderSessionDate: (orderSessionDate: string) => void;
        setReferrer: (referrer: string) => void;
        setPath: (path: string) => void;
    };
}
